import React, { FC, PropsWithChildren, ReactNode, useCallback } from "react";
import { useCopyText } from "@shared/hooks/CopyTextHook";
import classnames from "classnames";

import "./index.scss";

export type ButtonCopyProps = PropsWithChildren<{
  textToCopy: ReactNode;
  disabled?: boolean;
  successMessage?: string;
  failureMessage?: string;
}>;

export const ButtonCopy: FC<ButtonCopyProps> = ({ children, disabled, textToCopy, successMessage, failureMessage }) => {
  const handleCopy = useCopyText({
    successMessage,
    failureMessage,
  });

  const handleClick = useCallback(() => handleCopy(textToCopy), [handleCopy, textToCopy]);

  return (
    <span role="button" className={classnames("button-copy", { disabled })} onClick={handleClick}>
      {children}
    </span>
  );
};
